import { FlexiToggle } from "appworks/graphics/elements/flexi-toggle";
import { Services } from "appworks/services/services";
import { ToggleControl } from "appworks/ui/controls/standard/toggle/toggle-control";
import { uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { deviceInfo } from "appworks/utils/device-info";
import { SignalBinding } from "signals";

export class EpicAutoplayControl extends ToggleControl {
    protected binding: SignalBinding;

    constructor(button: FlexiToggle) {
        super(button);

        if (this.binding) {
            this.binding.detach();
        }

        this.binding = uiFlags.onFlagsUpdated.add(() => {
            if (deviceInfo.layoutId === "mobile") {
                this.button.setVisible(!uiFlags.has(UIMenuFlag.RULES));
            }
        });
    }

    public setEnabled(enabled: boolean) {
        const juriAllowsAutoplay = Services.jurisdiction.getAutoplayEnabled();

        if (!juriAllowsAutoplay) {
            super.setEnabled(false);
            this.button.setVisible(false);
        } else {
            super.setEnabled(enabled);
        }
    }
}
